import React from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from 'react-bootstrap';

const STATUS_BG = {
  Draft: 'secondary',
  Sent: 'primary',
  Opened: 'info',
  Completed: 'success',
  Archived: 'dark',
  Cancelled: 'danger',
};

const StatusBadge = ({ status }) => {
  const { t } = useTranslation();
  const bg = STATUS_BG[status] || 'secondary';
  const label = status ? t(`status.${status}`, { defaultValue: status }) : t('status.Unknown');
  return (
    <Badge bg={bg} className="text-uppercase" style={{ fontSize: '0.7rem', letterSpacing: '0.04em' }}>
      {label}
    </Badge>
  );
};

export default StatusBadge;
